import Dog from 'assets/avatar/Dog.png';
import Female from 'assets/avatar/Female.png';
import Male from 'assets/avatar/Male.png';

export const avatarList = [Male, Female, Dog];
